/* tslint:disable */
/* eslint-disable */
/**
 * Titan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssetAssigneeDto } from '../models';
// @ts-ignore
import type { AssetCategoryDtoListApiResponse } from '../models';
// @ts-ignore
import type { AssetDepartmentDto } from '../models';
// @ts-ignore
import type { AssetDepartmentDtoIEnumerableApiResponse } from '../models';
// @ts-ignore
import type { AssetDto } from '../models';
// @ts-ignore
import type { AssetDtoApiResponse } from '../models';
// @ts-ignore
import type { AssetDtoIEnumerableApiResponse } from '../models';
// @ts-ignore
import type { AssetTagDtoIEnumerableApiResponse } from '../models';
// @ts-ignore
import type { AssetTransactionDto } from '../models';
// @ts-ignore
import type { AssetTransactionDtoIEnumerableApiResponse } from '../models';
// @ts-ignore
import type { CreateAssetCategoryCommand } from '../models';
// @ts-ignore
import type { ETransactionType } from '../models';
// @ts-ignore
import type { Int32ApiResponse } from '../models';
/**
 * AssetApi - axios parameter creator
 * @export
 */
export const AssetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get users and groups to assign asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetAssigneesGet: async (page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Assignees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }

            if (categories) {
                localVarQueryParameter['Categories'] = categories;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['DepartmentId'] = departmentId;
            }

            if (date !== undefined) {
                localVarQueryParameter['Date'] = date;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users and groups assigned to asset by asset id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetAssigneesIdGet: async (id: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetAssigneesIdGet', 'id', id)
            const localVarPath = `/Asset/Assignees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCategoryGet: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {CreateAssetCategoryCommand} [createAssetCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCategoryPost: async (token?: string, createAssetCategoryCommand?: CreateAssetCategoryCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssetCategoryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDetailIdGet: async (id: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetDetailIdGet', 'id', id)
            const localVarPath = `/Asset/Detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetExportByFilterGet: async (page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/ExportByFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }

            if (categories) {
                localVarQueryParameter['Categories'] = categories;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['DepartmentId'] = departmentId;
            }

            if (date !== undefined) {
                localVarQueryParameter['Date'] = date;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [date] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetExportPost: async (date?: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGet: async (page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }

            if (categories) {
                localVarQueryParameter['Categories'] = categories;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['DepartmentId'] = departmentId;
            }

            if (date !== undefined) {
                localVarQueryParameter['Date'] = date;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetByCodeGet: async (code?: string, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/GetByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get assets by employee id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetByEmployeeIdIdGet: async (id: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetGetByEmployeeIdIdGet', 'id', id)
            const localVarPath = `/Asset/GetByEmployeeId/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetIdDelete: async (id: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetIdDelete', 'id', id)
            const localVarPath = `/Asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get detail asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetIdGet: async (id: number, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetIdGet', 'id', id)
            const localVarPath = `/Asset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetImportPost: async (token?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetImportToUpdatePost: async (token?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/ImportToUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetMigrateCategoryPost: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/MigrateCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetMigrateImagePost: async (token?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/MigrateImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPost: async (token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.append('CategoryId', categoryId as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.append('Category', category as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('Description', description as any);
            }
    
            if (unit !== undefined) { 
                localVarFormParams.append('Unit', unit as any);
            }
    
            if (quantity !== undefined) { 
                localVarFormParams.append('Quantity', quantity as any);
            }
    
            if (serialNumber !== undefined) { 
                localVarFormParams.append('SerialNumber', serialNumber as any);
            }
    
            if (brand !== undefined) { 
                localVarFormParams.append('Brand', brand as any);
            }
    
            if (purchaseDate !== undefined) { 
                localVarFormParams.append('PurchaseDate', purchaseDate as any);
            }
    
            if (purchasePrice !== undefined) { 
                localVarFormParams.append('PurchasePrice', purchasePrice as any);
            }
    
            if (supplier !== undefined) { 
                localVarFormParams.append('Supplier', supplier as any);
            }
    
            if (warrantyMonths !== undefined) { 
                localVarFormParams.append('WarrantyMonths', warrantyMonths as any);
            }
                if (tags) {
                tags.forEach((element) => {
                    localVarFormParams.append('Tags', element as any);
                })
            }

    
            if (tag !== undefined) { 
                localVarFormParams.append('Tag', tag as any);
            }
    
            if (isAssigned !== undefined) { 
                localVarFormParams.append('IsAssigned', String(isAssigned) as any);
            }
                if (assignees) {
                assignees.forEach((element) => {
                    localVarFormParams.append('Assignees', element as any);
                })
            }

    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('Image', image as any);
            }
    
            if (area !== undefined) { 
                localVarFormParams.append('Area', area as any);
            }
                if (transactions) {
                transactions.forEach((element) => {
                    localVarFormParams.append('Transactions', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPut: async (token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.append('CategoryId', categoryId as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.append('Category', category as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('Description', description as any);
            }
    
            if (unit !== undefined) { 
                localVarFormParams.append('Unit', unit as any);
            }
    
            if (quantity !== undefined) { 
                localVarFormParams.append('Quantity', quantity as any);
            }
    
            if (serialNumber !== undefined) { 
                localVarFormParams.append('SerialNumber', serialNumber as any);
            }
    
            if (brand !== undefined) { 
                localVarFormParams.append('Brand', brand as any);
            }
    
            if (purchaseDate !== undefined) { 
                localVarFormParams.append('PurchaseDate', purchaseDate as any);
            }
    
            if (purchasePrice !== undefined) { 
                localVarFormParams.append('PurchasePrice', purchasePrice as any);
            }
    
            if (supplier !== undefined) { 
                localVarFormParams.append('Supplier', supplier as any);
            }
    
            if (warrantyMonths !== undefined) { 
                localVarFormParams.append('WarrantyMonths', warrantyMonths as any);
            }
                if (tags) {
                tags.forEach((element) => {
                    localVarFormParams.append('Tags', element as any);
                })
            }

    
            if (tag !== undefined) { 
                localVarFormParams.append('Tag', tag as any);
            }
    
            if (isAssigned !== undefined) { 
                localVarFormParams.append('IsAssigned', String(isAssigned) as any);
            }
                if (assignees) {
                assignees.forEach((element) => {
                    localVarFormParams.append('Assignees', element as any);
                })
            }

    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('Image', image as any);
            }
    
            if (area !== undefined) { 
                localVarFormParams.append('Area', area as any);
            }
                if (transactions) {
                transactions.forEach((element) => {
                    localVarFormParams.append('Transactions', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTagsGet: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new asset transaction
         * @param {string} [token] 
         * @param {number} [assetId] 
         * @param {string} [transactionType] 
         * @param {number} [quantity] 
         * @param {number} [employeeId] 
         * @param {number} [toEmployeeId] 
         * @param {number} [groupId] 
         * @param {number} [toGroupId] 
         * @param {number} [departmentId] 
         * @param {number} [toDepartmentId] 
         * @param {string} [reason] 
         * @param {number} [transactionDate] 
         * @param {Array<File>} [images] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTransactionPost: async (token?: string, assetId?: number, transactionType?: string, quantity?: number, employeeId?: number, toEmployeeId?: number, groupId?: number, toGroupId?: number, departmentId?: number, toDepartmentId?: number, reason?: string, transactionDate?: number, images?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


            if (assetId !== undefined) { 
                localVarFormParams.append('AssetId', assetId as any);
            }
    
            if (transactionType !== undefined) { 
                localVarFormParams.append('TransactionType', transactionType as any);
            }
    
            if (quantity !== undefined) { 
                localVarFormParams.append('Quantity', quantity as any);
            }
    
            if (employeeId !== undefined) { 
                localVarFormParams.append('EmployeeId', employeeId as any);
            }
    
            if (toEmployeeId !== undefined) { 
                localVarFormParams.append('ToEmployeeId', toEmployeeId as any);
            }
    
            if (groupId !== undefined) { 
                localVarFormParams.append('GroupId', groupId as any);
            }
    
            if (toGroupId !== undefined) { 
                localVarFormParams.append('ToGroupId', toGroupId as any);
            }
    
            if (departmentId !== undefined) { 
                localVarFormParams.append('DepartmentId', departmentId as any);
            }
    
            if (toDepartmentId !== undefined) { 
                localVarFormParams.append('ToDepartmentId', toDepartmentId as any);
            }
    
            if (reason !== undefined) { 
                localVarFormParams.append('Reason', reason as any);
            }
    
            if (transactionDate !== undefined) { 
                localVarFormParams.append('TransactionDate', transactionDate as any);
            }
                if (images) {
                images.forEach((element) => {
                    localVarFormParams.append('Images', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get asset transactions by transaction type
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ETransactionType} [type] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTransactionsGet: async (page?: number, pageSize?: number, search?: string, type?: ETransactionType, sortBy?: string, isDescending?: boolean, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetApi - functional programming interface
 * @export
 */
export const AssetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get users and groups to assign asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetAssigneesGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDepartmentDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetAssigneesGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetAssigneesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users and groups assigned to asset by asset id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetAssigneesIdGet(id: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDepartmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetAssigneesIdGet(id, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetAssigneesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetCategoryGet(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCategoryDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetCategoryGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetCategoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {CreateAssetCategoryCommand} [createAssetCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetCategoryPost(token?: string, createAssetCategoryCommand?: CreateAssetCategoryCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetCategoryPost(token, createAssetCategoryCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetCategoryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetDetailIdGet(id: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetDetailIdGet(id, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetDetailIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetExportByFilterGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetExportByFilterGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetExportByFilterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [date] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetExportPost(date?: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetExportPost(date, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetGetByCodeGet(code?: string, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetGetByCodeGet(code, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetGetByCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get assets by employee id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetGetByEmployeeIdIdGet(id: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetGetByEmployeeIdIdGet(id, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetGetByEmployeeIdIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetIdDelete(id: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetIdDelete(id, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get detail asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetIdGet(id: number, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetIdGet(id, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetImportPost(token?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetImportPost(token, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetImportToUpdatePost(token?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetImportToUpdatePost(token, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetImportToUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetMigrateCategoryPost(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetMigrateCategoryPost(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetMigrateCategoryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetMigrateImagePost(token?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetMigrateImagePost(token, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetMigrateImagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create new asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetPost(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetPost(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetPut(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetPut(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetTagsGet(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetTagDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetTagsGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetTagsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create new asset transaction
         * @param {string} [token] 
         * @param {number} [assetId] 
         * @param {string} [transactionType] 
         * @param {number} [quantity] 
         * @param {number} [employeeId] 
         * @param {number} [toEmployeeId] 
         * @param {number} [groupId] 
         * @param {number} [toGroupId] 
         * @param {number} [departmentId] 
         * @param {number} [toDepartmentId] 
         * @param {string} [reason] 
         * @param {number} [transactionDate] 
         * @param {Array<File>} [images] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetTransactionPost(token?: string, assetId?: number, transactionType?: string, quantity?: number, employeeId?: number, toEmployeeId?: number, groupId?: number, toGroupId?: number, departmentId?: number, toDepartmentId?: number, reason?: string, transactionDate?: number, images?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetTransactionPost(token, assetId, transactionType, quantity, employeeId, toEmployeeId, groupId, toGroupId, departmentId, toDepartmentId, reason, transactionDate, images, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetTransactionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get asset transactions by transaction type
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ETransactionType} [type] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetTransactionsGet(page?: number, pageSize?: number, search?: string, type?: ETransactionType, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetTransactionDtoIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetTransactionsGet(page, pageSize, search, type, sortBy, isDescending, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetApi - factory interface
 * @export
 */
export const AssetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetApiFp(configuration)
    return {
        /**
         * 
         * @summary Get users and groups to assign asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetAssigneesGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: any): AxiosPromise<AssetDepartmentDtoIEnumerableApiResponse> {
            return localVarFp.assetAssigneesGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users and groups assigned to asset by asset id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetAssigneesIdGet(id: number, token?: string, options?: any): AxiosPromise<Array<AssetDepartmentDto>> {
            return localVarFp.assetAssigneesIdGet(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCategoryGet(token?: string, options?: any): AxiosPromise<AssetCategoryDtoListApiResponse> {
            return localVarFp.assetCategoryGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {CreateAssetCategoryCommand} [createAssetCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCategoryPost(token?: string, createAssetCategoryCommand?: CreateAssetCategoryCommand, options?: any): AxiosPromise<Int32ApiResponse> {
            return localVarFp.assetCategoryPost(token, createAssetCategoryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDetailIdGet(id: number, token?: string, options?: any): AxiosPromise<AssetDtoApiResponse> {
            return localVarFp.assetDetailIdGet(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetExportByFilterGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: any): AxiosPromise<AssetDtoIEnumerableApiResponse> {
            return localVarFp.assetExportByFilterGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [date] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetExportPost(date?: number, token?: string, options?: any): AxiosPromise<void> {
            return localVarFp.assetExportPost(date, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all asset
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<number>} [tags] 
         * @param {Array<number>} [categories] 
         * @param {number} [departmentId] 
         * @param {number} [date] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: any): AxiosPromise<AssetDtoIEnumerableApiResponse> {
            return localVarFp.assetGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetByCodeGet(code?: string, token?: string, options?: any): AxiosPromise<AssetDto> {
            return localVarFp.assetGetByCodeGet(code, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get assets by employee id
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetByEmployeeIdIdGet(id: number, token?: string, options?: any): AxiosPromise<AssetDtoIEnumerableApiResponse> {
            return localVarFp.assetGetByEmployeeIdIdGet(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetIdDelete(id: number, token?: string, options?: any): AxiosPromise<void> {
            return localVarFp.assetIdDelete(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get detail asset by assetId
         * @param {number} id 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetIdGet(id: number, token?: string, options?: any): AxiosPromise<AssetDto> {
            return localVarFp.assetIdGet(id, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetImportPost(token?: string, file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.assetImportPost(token, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetImportToUpdatePost(token?: string, file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.assetImportToUpdatePost(token, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetMigrateCategoryPost(token?: string, options?: any): AxiosPromise<void> {
            return localVarFp.assetMigrateCategoryPost(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetMigrateImagePost(token?: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.assetMigrateImagePost(token, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPost(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: any): AxiosPromise<void> {
            return localVarFp.assetPost(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update asset
         * @param {string} [token] 
         * @param {number} [id] 
         * @param {string} [name] 
         * @param {number} [categoryId] 
         * @param {string} [category] 
         * @param {string} [description] 
         * @param {string} [unit] 
         * @param {number} [quantity] 
         * @param {string} [serialNumber] 
         * @param {string} [brand] 
         * @param {number} [purchaseDate] 
         * @param {string} [purchasePrice] 
         * @param {string} [supplier] 
         * @param {number} [warrantyMonths] 
         * @param {Array<string>} [tags] 
         * @param {string} [tag] 
         * @param {boolean} [isAssigned] 
         * @param {Array<AssetAssigneeDto>} [assignees] 
         * @param {File} [file] 
         * @param {string} [image] 
         * @param {string} [area] 
         * @param {Array<AssetTransactionDto>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPut(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: any): AxiosPromise<void> {
            return localVarFp.assetPut(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTagsGet(token?: string, options?: any): AxiosPromise<AssetTagDtoIEnumerableApiResponse> {
            return localVarFp.assetTagsGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new asset transaction
         * @param {string} [token] 
         * @param {number} [assetId] 
         * @param {string} [transactionType] 
         * @param {number} [quantity] 
         * @param {number} [employeeId] 
         * @param {number} [toEmployeeId] 
         * @param {number} [groupId] 
         * @param {number} [toGroupId] 
         * @param {number} [departmentId] 
         * @param {number} [toDepartmentId] 
         * @param {string} [reason] 
         * @param {number} [transactionDate] 
         * @param {Array<File>} [images] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTransactionPost(token?: string, assetId?: number, transactionType?: string, quantity?: number, employeeId?: number, toEmployeeId?: number, groupId?: number, toGroupId?: number, departmentId?: number, toDepartmentId?: number, reason?: string, transactionDate?: number, images?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.assetTransactionPost(token, assetId, transactionType, quantity, employeeId, toEmployeeId, groupId, toGroupId, departmentId, toDepartmentId, reason, transactionDate, images, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get asset transactions by transaction type
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {ETransactionType} [type] 
         * @param {string} [sortBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetTransactionsGet(page?: number, pageSize?: number, search?: string, type?: ETransactionType, sortBy?: string, isDescending?: boolean, token?: string, options?: any): AxiosPromise<AssetTransactionDtoIEnumerableApiResponse> {
            return localVarFp.assetTransactionsGet(page, pageSize, search, type, sortBy, isDescending, token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetApi - object-oriented interface
 * @export
 * @class AssetApi
 * @extends {BaseAPI}
 */
export class AssetApi extends BaseAPI {
    /**
     * 
     * @summary Get users and groups to assign asset
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {Array<number>} [tags] 
     * @param {Array<number>} [categories] 
     * @param {number} [departmentId] 
     * @param {number} [date] 
     * @param {string} [sortBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetAssigneesGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetAssigneesGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users and groups assigned to asset by asset id
     * @param {number} id 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetAssigneesIdGet(id: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetAssigneesIdGet(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetCategoryGet(token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetCategoryGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {CreateAssetCategoryCommand} [createAssetCategoryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetCategoryPost(token?: string, createAssetCategoryCommand?: CreateAssetCategoryCommand, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetCategoryPost(token, createAssetCategoryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetDetailIdGet(id: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetDetailIdGet(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {Array<number>} [tags] 
     * @param {Array<number>} [categories] 
     * @param {number} [departmentId] 
     * @param {number} [date] 
     * @param {string} [sortBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetExportByFilterGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetExportByFilterGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [date] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetExportPost(date?: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetExportPost(date, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all asset
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {Array<number>} [tags] 
     * @param {Array<number>} [categories] 
     * @param {number} [departmentId] 
     * @param {number} [date] 
     * @param {string} [sortBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetGet(page?: number, pageSize?: number, search?: string, tags?: Array<number>, categories?: Array<number>, departmentId?: number, date?: number, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetGet(page, pageSize, search, tags, categories, departmentId, date, sortBy, isDescending, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetGetByCodeGet(code?: string, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetGetByCodeGet(code, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get assets by employee id
     * @param {number} id 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetGetByEmployeeIdIdGet(id: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetGetByEmployeeIdIdGet(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove asset by assetId
     * @param {number} id 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetIdDelete(id: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetIdDelete(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get detail asset by assetId
     * @param {number} id 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetIdGet(id: number, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetIdGet(id, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetImportPost(token?: string, file?: File, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetImportPost(token, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetImportToUpdatePost(token?: string, file?: File, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetImportToUpdatePost(token, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetMigrateCategoryPost(token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetMigrateCategoryPost(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetMigrateImagePost(token?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetMigrateImagePost(token, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new asset
     * @param {string} [token] 
     * @param {number} [id] 
     * @param {string} [name] 
     * @param {number} [categoryId] 
     * @param {string} [category] 
     * @param {string} [description] 
     * @param {string} [unit] 
     * @param {number} [quantity] 
     * @param {string} [serialNumber] 
     * @param {string} [brand] 
     * @param {number} [purchaseDate] 
     * @param {string} [purchasePrice] 
     * @param {string} [supplier] 
     * @param {number} [warrantyMonths] 
     * @param {Array<string>} [tags] 
     * @param {string} [tag] 
     * @param {boolean} [isAssigned] 
     * @param {Array<AssetAssigneeDto>} [assignees] 
     * @param {File} [file] 
     * @param {string} [image] 
     * @param {string} [area] 
     * @param {Array<AssetTransactionDto>} [transactions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetPost(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetPost(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update asset
     * @param {string} [token] 
     * @param {number} [id] 
     * @param {string} [name] 
     * @param {number} [categoryId] 
     * @param {string} [category] 
     * @param {string} [description] 
     * @param {string} [unit] 
     * @param {number} [quantity] 
     * @param {string} [serialNumber] 
     * @param {string} [brand] 
     * @param {number} [purchaseDate] 
     * @param {string} [purchasePrice] 
     * @param {string} [supplier] 
     * @param {number} [warrantyMonths] 
     * @param {Array<string>} [tags] 
     * @param {string} [tag] 
     * @param {boolean} [isAssigned] 
     * @param {Array<AssetAssigneeDto>} [assignees] 
     * @param {File} [file] 
     * @param {string} [image] 
     * @param {string} [area] 
     * @param {Array<AssetTransactionDto>} [transactions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetPut(token?: string, id?: number, name?: string, categoryId?: number, category?: string, description?: string, unit?: string, quantity?: number, serialNumber?: string, brand?: string, purchaseDate?: number, purchasePrice?: string, supplier?: string, warrantyMonths?: number, tags?: Array<string>, tag?: string, isAssigned?: boolean, assignees?: Array<AssetAssigneeDto>, file?: File, image?: string, area?: string, transactions?: Array<AssetTransactionDto>, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetPut(token, id, name, categoryId, category, description, unit, quantity, serialNumber, brand, purchaseDate, purchasePrice, supplier, warrantyMonths, tags, tag, isAssigned, assignees, file, image, area, transactions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetTagsGet(token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetTagsGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new asset transaction
     * @param {string} [token] 
     * @param {number} [assetId] 
     * @param {string} [transactionType] 
     * @param {number} [quantity] 
     * @param {number} [employeeId] 
     * @param {number} [toEmployeeId] 
     * @param {number} [groupId] 
     * @param {number} [toGroupId] 
     * @param {number} [departmentId] 
     * @param {number} [toDepartmentId] 
     * @param {string} [reason] 
     * @param {number} [transactionDate] 
     * @param {Array<File>} [images] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetTransactionPost(token?: string, assetId?: number, transactionType?: string, quantity?: number, employeeId?: number, toEmployeeId?: number, groupId?: number, toGroupId?: number, departmentId?: number, toDepartmentId?: number, reason?: string, transactionDate?: number, images?: Array<File>, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetTransactionPost(token, assetId, transactionType, quantity, employeeId, toEmployeeId, groupId, toGroupId, departmentId, toDepartmentId, reason, transactionDate, images, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get asset transactions by transaction type
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {ETransactionType} [type] 
     * @param {string} [sortBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public assetTransactionsGet(page?: number, pageSize?: number, search?: string, type?: ETransactionType, sortBy?: string, isDescending?: boolean, token?: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetTransactionsGet(page, pageSize, search, type, sortBy, isDescending, token, options).then((request) => request(this.axios, this.basePath));
    }
}

